import { useQuery } from '@tanstack/react-query';
import { getMembershipChangeLogs } from './api';
import { membershipChangeLogKeys } from './keys';
import { ChangeLogTargetType } from './types';

export const useMembershipChangeLogs = ({
    targetType,
    targetId,
    memberId,
    includeSystem = false,
    enabled = true,
}: {
    targetType: ChangeLogTargetType;
    targetId: string;
    memberId?: string;
    includeSystem?: boolean;
    enabled?: boolean;
}) =>
    useQuery({
        queryKey: membershipChangeLogKeys.forTarget(targetType, targetId, includeSystem),
        queryFn: () => getMembershipChangeLogs({ targetType, targetId, memberId, includeSystem }),
        enabled: enabled && !!targetId,
        select: (data) => ({
            results: data?.data?.results ?? [],
            totalResults: data?.data?.totalResults ?? 0,
        }),
    });
